import React, { useEffect, useState } from "react";
import Speedomer from "../assets/img/speedometer.svg";
import member from "../assets/img/member_icon.svg";
import downarrao from "../assets/img/down-arrow.svg";
import star from "../assets/img/star.svg";
import meeting from "../assets/img/meetingWith.png";
import business from "../assets/img/business-relationship.svg";
import headicon from "../assets/img/head-idea-icon.svg";
import bag from "../assets/img/shopping-bag-icon.svg";
import flagicon from "../assets/img/flag_icon.svg";
import book from "../assets/img/book.svg";
import alaram from "../assets/img/alarm.svg";
import workplace from "../assets/img/workplace-icon.svg";
import phone from "../assets/img/phone.svg";
import Logout from "../assets/img/logout.svg";
import Header from "./Header";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLocalization } from "./Localization/Localization";
function Sidebar() {
  const { t } = useLocalization();
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const [active, setActive] = useState("");
  const navigate = useNavigate();

  const setActiveTab = (tab) => {
    if (active == tab) {
      setActive("");
    } else {
      setActive(tab);
    }
  };

  useEffect(() => {
    if (document.body.classList == "toggle-sidebar") {
      document.body.classList.remove("toggle-sidebar");
    }
  }, [visible]);

  return (
    <div>
      <aside id="sidebar" className="sidebar">
        <ul className="sidebar-nav" id="sidebar-nav">
          <li className="nav-item">
            <Link
              onClick={() => {
                setVisible(!visible);
              }}
              className={
                location.pathname == "/dashboard"
                  ? "nav-link active"
                  : "nav-link"
              }
              to="/dashboard"
            >
              <i className="side-icon">
                {" "}
                <img className="img-fluid" src={Speedomer} alt="" />
              </i>
              <span>{t("dashboard")}</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link
              // className={active == "Roles" ? "nav-link" : "nav-link collapsed"}

              onClick={() => {
                setActiveTab("assignment");
              }}
              className={
                active == "assignment"
                  ? "nav-link"
                  : location.pathname == "/Assignment/awarenessCourses" ||
                    location.pathname == "/Assignment/worksheet" ||
                    // location.pathname == "/Assignment/lab" ||
                    location.pathname == "/Assignment/assessment"
                  ? "nav-link collapsed active"
                  : "nav-link collapsed"
              }
            >
              <i className="side-icon">
                {" "}
                <img className="img-fluid" src={business} alt="" />
              </i>
              <span>{t("assignments")}</span>
              <i className="dropdown-icon ms-auto">
                <img className="img-fluid" src={downarrao} alt="" />
              </i>
            </Link>
            <ul
              id="components-delegation"
              className={
                active == "assignment" ? "nav-content " : "nav-content collapse"
              }
            >
              <li
                onClick={() => {
                  setVisible(!visible);
                }}
              >
                <Link to="/Assignment/awarenessCourses">
                  <i className="bi bi-circle"></i>
                  <span>{t("awareness_courses")}</span>
                </Link>
              </li>
              <li
                onClick={() => {
                  setVisible(!visible);
                }}
              >
                <Link to="/Assignment/worksheet">
                  <i className="bi bi-circle"></i>
                  <span>{t("worksheet")}</span>
                </Link>
              </li>
              {/* <li>
                <Link to="/Assignment/assessment">
                  <i className="bi bi-circle"></i>
                  <span>{t("assessment")}</span>
                </Link>
              </li> */}

              {/* <li>
                <Link to="/Assignment/lab">
                  <i className="bi bi-circle"></i>
                  <span>{t("lab")}</span>
                </Link>
              </li> */}
            </ul>
          </li>

          <li className="nav-item">
            <Link
              // className={active == "Roles" ? "nav-link" : "nav-link collapsed"}
              onClick={() => setActiveTab("elibrary")}
              className={
                active == "elibrary"
                  ? "nav-link"
                  : location.pathname == "/elibrary/awarenessCourses" ||
                    location.pathname == "/elibrary/worksheet" ||
                    // location.pathname == "/elibrary/lab" ||
                    location.pathname == "/elibrary/assesment"
                  ? "nav-link collapsed active"
                  : "nav-link collapsed"
              }
            >
              <i className="side-icon">
                {" "}
                <img className="img-fluid" src={business} alt="" />
              </i>
              <span>{t("elib")}</span>
              <i className="dropdown-icon ms-auto">
                <img className="img-fluid" src={downarrao} alt="" />
              </i>
            </Link>
            <ul
              id="components-delegation"
              className={
                active == "elibrary" ? "nav-content " : "nav-content collapse"
              }
            >
              <li
                onClick={() => {
                  setVisible(!visible);
                }}
              >
                <Link to="/elibrary/awarenessCourses">
                  <i className="bi bi-circle"></i>
                  <span>{t("awareness_courses")}</span>
                </Link>
              </li>
              <li
                onClick={() => {
                  setVisible(!visible);
                }}
              >
                <Link to="/elibrary/worksheet">
                  <i className="bi bi-circle"></i>
                  <span>{t("worksheet")}</span>
                </Link>
              </li>
              {/* <li>
                <Link to="/elibrary/assessment">
                  <i className="bi bi-circle"></i>
                  <span>{t("assessment")}</span>
                </Link>
              </li> */}
              {/* 
              <li>
                <Link to="/elibrary/lab">
                  <i className="bi bi-circle"></i>
                  <span>{t("lab")}</span>
                </Link>
              </li> */}
            </ul>
          </li>

          <li
            className="nav-item"
            onClick={() => {
              localStorage.clear();
              navigate("/login");
            }}
          >
            <span className="nav-link collapsed logout-span">
              <i className="side-icon">
                <img className="img-fluid" src={Logout} alt="" />
              </i>
              <span>{t("log_out")}</span>
            </span>
          </li>
        </ul>
      </aside>
    </div>
  );
}

export default Sidebar;
